import * as babel from 'babel-polyfill';
import { observable, action, runInAction } from 'mobx';
import { remoteAction } from '../../../js/common/utils';

class Stores {
    @observable lastNameKanji;
    @observable firstNameKanji;
    @observable lastNameKana;
    @observable firstNameKana;
    @observable staffCode;
    @observable phone;
    @observable mail;
    @observable detail;
    @observable isLoading;
    @observable showError;
    @observable errMode;
    @observable errMessage;
    @observable isAgreed;
    @observable isScrolldBottom;

    constructor() {
        this.lastNameKanji = '';
        this.firstNameKanji = '';
        this.lastNameKana = '';
        this.firstNameKana = '';
        this.staffCode = '';
        this.phone = '';
        this.mail = '';
        this.detail = '';
        this.isLoading = false;
        this.showError = false;
        this.errMode = 'success';
        this.errMessage = '';
        this.isAgreed = false;
        this.isScrolldBottom = false;
    }

    @action
    createCatchTheHeartInquiry = async (router) => {

        this.clearError();
        this.isLoading = true;
        let inquiry;
        inquiry = this.toJS();

        try {
            const inquiryId = await remoteAction('TPNS_CatchTheHeartInquiryCtrl.createCatchTheHeart', JSON.stringify(inquiry));
            runInAction('run in createCatchTheHeart', () => {
                if (inquiryId != null) {
                    router.push('step3');
                }
            });
        } catch (e) {
            this.showErrorMessage('danger', e.message);
        }
        this.isLoading = false;
    };

    @action showErrorMessage(errMode, errMessage) {
        this.showError = true;
        this.errMode = errMode;
        this.errMessage = errMessage;
    }

    @action clearError() {
        this.showError = false;
        this.errContent = '';
    }

    toJS() {
        return {
            lastNameKanji: this.lastNameKanji,
            firstNameKanji: this.firstNameKanji,
            lastNameKana: this.lastNameKana,
            firstNameKana: this.firstNameKana,
            staffCode: this.staffCode,
            phone: this.phone,
            mail: this.mail,
            detail: this.detail,
        };
    }
}

export default new Stores();
